<div [hidden]="skeletonPage">
    @if (regions().length && !hideFilters) {
        <div class="region-country-navigation" [class.region-navigation-list]="!isMobileMode || !isEpcotEnabled">
            <ms-scroll-adapter class="ps__child--consume" [scrollItems]="regions()">
                <ul class="pill-live-list">
                    @for (region of regions(); track region.id) {
                        <li>
                            <a
                                ds-pill
                                msThemedPills
                                size="small"
                                [msLink]="region"
                                [themedInverse]="themeInverseIndicator"
                                [vnSpeculativeLink]="region.url"
                                [selected]="selectedRegion()?.id === region.id"
                                (click)="onSelected($event, region)">
                                @if (region.icon) {
                                    <i class="icon" slot="start" [ngClass]="region.icon"></i>
                                }
                                {{ region.title }}
                            </a>
                        </li>
                    }
                </ul>
            </ms-scroll-adapter>
        </div>
    }

    <router-outlet />
</div>

<div [hidden]="!skeletonPage">
    @if (skeletonPage) {
        <ms-skeleton-livepage [pageName]="skeletonPage" />
    }
</div>
